export const getStructureIdFromUrl = (url: string) => {
    const arr = url.split('/');
    const foundIndex = arr.findIndex((item) => item.includes('structures'));
    return arr[foundIndex + 1];
};
